export default "__VITE_ASSET__f3baec3a__"